export const lkLogoLoader = () => () => import(VITE_LK_LOGO_NAME);
export const publicLogoLoader = () => () => import(VITE_PUB_LOGO_NAME);
